module.exports = __webpack_public_path__ + "img/MySQLl.7bb98e39.svg";